<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    @close="closeDialogVisible"
    width="1200"
  >
    <el-form label-width="110px">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item required label="提示标题：">
            <div class="introduction-editor">
              <div class="introduction-editor-header">中文</div>
              <el-input
                v-model="tipTitle.zh"
                @input="changeText('tipTitle')"
                type="textarea"
                :rows="2"
              ></el-input>
            </div>
            <div class="introduction-editor">
              <div class="introduction-editor-header">英文</div>
              <el-input
                v-model="tipTitle.en"
                @input="changeText('tipTitle')"
                type="textarea"
                :rows="2"
              ></el-input>
            </div>
            <div class="introduction-editor">
              <div class="introduction-editor-header">越南语</div>
              <el-input
                v-model="tipTitle.vi"
                @input="changeText('tipTitle')"
                type="textarea"
                :rows="2"
              ></el-input>
            </div>
            <div class="introduction-editor">
              <div class="introduction-editor-header">韩语</div>
              <el-input
                v-model="tipTitle.kr"
                @input="changeText('tipTitle')"
                type="textarea"
                :rows="2"
              ></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item required label="提示内容：">
            <div class="introduction-editor">
              <div class="introduction-editor-header">中文</div>
              <el-input
                v-model="tipContent.zh"
                @input="changeText('tipContent')"
                type="textarea"
                :rows="2"
              ></el-input>
            </div>
            <div class="introduction-editor">
              <div class="introduction-editor-header">英文</div>
              <el-input
                v-model="tipContent.en"
                @input="changeText('tipContent')"
                type="textarea"
                :rows="2"
              ></el-input>
            </div>
            <div class="introduction-editor">
              <div class="introduction-editor-header">越南语</div>
              <el-input
                v-model="tipContent.vi"
                @input="changeText('tipContent')"
                type="textarea"
                :rows="2"
              ></el-input>
            </div>
            <div class="introduction-editor">
              <div class="introduction-editor-header">韩语</div>
              <el-input
                v-model="tipContent.kr"
                @input="changeText('tipContent')"
                type="textarea"
                :rows="2"
              ></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="跳转显示信息：">
            <div class="introduction-editor">
              <div class="introduction-editor-header">中文</div>
              <el-input
                v-model="tipJumpMsg.zh"
                type="textarea"
                :rows="2"
              ></el-input>
            </div>
            <div class="introduction-editor">
              <div class="introduction-editor-header">英文</div>
              <el-input
                v-model="tipJumpMsg.en"
                type="textarea"
                :rows="2"
              ></el-input>
            </div>
            <div class="introduction-editor">
              <div class="introduction-editor-header">越南语</div>
              <el-input
                v-model="tipJumpMsg.vi"
                type="textarea"
                :rows="2"
              ></el-input>
            </div>
            <div class="introduction-editor">
              <div class="introduction-editor-header">韩语</div>
              <el-input
                v-model="tipJumpMsg.kr"
                type="textarea"
                :rows="2"
              ></el-input>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="跳转链接：">
        <el-input v-model="parames.jumpUrl" placeholder="请输入链接"></el-input>
      </el-form-item>
      <el-form-item label="显示/隐藏">
        <el-switch v-model="parames.showTip"></el-switch>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialogVisible">取 消</el-button>
      <el-button type="primary" @click="addOrUpdate">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import api from "./../api";
export default {
  name: "AddDialog",
  data() {
    return {
      dialogVisible: false,
      title: "添加用户提示",
      parames: {
        jumpUrl: "",
        showTip: true,
        tipContent: "",
        tipJumpMsg: "",
        tipTitle: "",
      },
      tipContent: {
        zh: "",
        kr: "",
        en: "",
        vi: "",
      },
      tipJumpMsg: {
        zh: "",
        kr: "",
        en: "",
        vi: "",
      },
      tipTitle: {
        zh: "",
        kr: "",
        en: "",
        vi: "",
      },
    };
  },
  methods: {
    // 初始化开启
    initData(e) {
      if (e) {
        this.parames = JSON.parse(JSON.stringify(e));
        this.tipContent = JSON.parse(e.tipContent);
        this.tipJumpMsg = JSON.parse(e.tipJumpMsg);
        this.tipTitle = JSON.parse(e.tipTitle);
        this.title = "编辑用户提示";
      } else {
        this.title = "添加用户提示";
        this.parames = {
          jumpUrl: "",
          showTip: false,
          tipContent: "",
          tipJumpMsg: "",
          tipTitle: "",
        };
        this.tipContent = {
          zh: "",
          kr: "",
          en: "",
          vi: "",
        };
        this.tipJumpMsg = {
          zh: "",
          kr: "",
          en: "",
          vi: "",
        };
        this.tipTitle = {
          zh: "",
          kr: "",
          en: "",
          vi: "",
        };
      }
      this.dialogVisible = true;
    },
    // 编辑内容
    changeText(e) {
      if (
        this[e].zh !== "" &&
        this[e].kr !== "" &&
        this[e].en !== "" &&
        this[e].vi !== ""
      ) {
        this.parames[e] = JSON.stringify(this[e]);
      } else {
        this.parames[e] = "";
      }
    },
    // 编辑或者新增
    addOrUpdate() {
      if (this.parames.tipContent == "" || this.parames.tipTitle == "") {
        this.$message.error("标题和内容必填");
        return;
      }
      api
        .addOrUpdate({
          ...this.parames,
          tipContent: JSON.stringify(this.tipContent),
          tipTitle: JSON.stringify(this.tipTitle),
          tipJumpMsg: JSON.stringify(this.tipJumpMsg),
        })
        .then((res) => {
          if (res.code === 0) {
            this.dialogVisible = false;
            this.$emit("getList");
            this.$message.success("保存成功");
          }
        });
    },
    // 关闭弹窗
    closeDialogVisible() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped></style>
